import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1254.000000 1254.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)">

<path d="M7770 7190 c-8 -5 -12 -11 -10 -14 3 -2 14 2 24 10 22 15 10 19 -14
4z"/>
<path d="M5915 10740 c-643 -53 -1167 -345 -1462 -815 -68 -107 -141 -298
-164 -425 -21 -114 -16 -327 9 -430 64 -263 195 -464 436 -667 79 -67 125 -99
301 -212 86 -56 358 -186 522 -252 307 -121 705 -239 1013 -300 128 -25 161
-29 191 -20 66 20 89 93 49 158 -24 40 -80 81 -470 347 -720 489 -866 598
-981 726 -168 189 -229 385 -180 580 28 110 68 177 166 275 173 174 425 255
790 255 175 0 320 -18 463 -56 52 -14 96 -23 99 -21 2 3 -9 8 -26 12 -16 3
-31 14 -33 23 -2 10 -24 23 -58 33 l-55 17 50 -4 c28 -2 41 -1 30 2 -35 11
-44 36 -45 124 0 74 -3 87 -20 98 -12 7 -20 23 -20 40 0 16 -8 34 -20 42 -12
8 -20 26 -20 42 0 15 -4 28 -9 28 -18 0 -71 91 -71 120 0 36 -19 80 -35 80
-13 0 -29 56 -20 70 2 4 -7 13 -20 20 -25 13 -34 30 -16 30 5 0 9 11 9 25 0
26 -7 28 -98 39 -19 2 0 3 42 2 43 -1 74 2 70 6 -12 12 -299 17 -417 8z m362
-36 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m200 -750 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m102 -20 c10 -9 -35 -3 -49 6
-11 8 -7 9 15 4 17 -4 32 -8 34 -10z m46 -14 c8 -13 -5 -13 -25 0 -13 8 -13
10 2 10 9 0 20 -4 23 -10z"/>
<path d="M6408 10723 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6478 10713 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6710 9877 c0 -3 15 -10 32 -16 18 -6 28 -7 23 -2 -12 10 -55 25 -55
18z"/>
<path d="M7835 9190 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M5783 9169 c-12 -6 -29 -27 -39 -47 -13 -29 -14 -41 -5 -73 15 -51
46 -85 128 -142 77 -54 402 -279 728 -505 534 -370 604 -425 736 -578 136
-159 234 -342 279 -524 30 -121 37 -336 16 -457 -70 -400 -347 -704 -761 -836
-199 -63 -265 -72 -520 -72 -239 0 -314 9 -500 56 -340 86 -652 262 -908 511
-115 111 -80 102 -420 108 l-298 5 -46 53 c-71 82 -143 110 -233 91 -147 -31
-222 -191 -154 -328 32 -64 86 -106 158 -122 44 -10 62 -9 111 6 48 14 68 27
116 77 55 58 59 60 117 65 97 9 108 3 147 -82 113 -249 304 -500 513 -676 307
-258 742 -455 1017 -460 44 -1 94 -5 110 -10 21 -6 11 -7 -34 -4 -98 7 -65 -6
66 -26 158 -25 446 -35 598 -20 401 39 812 195 1110 420 120 92 383 365 331
345 -8 -3 -18 -14 -21 -25 -4 -10 -10 -19 -16 -19 -5 0 1 17 12 37 16 29 17
34 4 23 -20 -17 -46 -65 -39 -73 3 -3 1 -14 -5 -24 -10 -17 -10 -17 -11 1 0
11 -5 16 -13 13 -7 -3 -22 2 -32 10 -19 14 -19 14 7 8 21 -5 30 -2 42 18 9 13
14 33 10 43 -4 14 -3 15 4 5 7 -9 12 -10 16 -2 12 20 -26 26 -40 6 -18 -25
-53 -40 -99 -44 -22 -1 -41 -7 -43 -12 -2 -5 -21 -9 -42 -9 -35 0 -39 -3 -42
-27 -3 -24 -8 -28 -40 -31 -24 -2 -38 -8 -38 -17 0 -14 -66 -25 -185 -28 -71
-2 -94 -14 -94 -47 0 -10 6 -8 19 9 11 13 20 18 20 11 0 -14 -55 -70 -69 -70
-14 0 -14 17 0 22 5 2 12 17 13 33 2 16 9 31 15 33 6 2 11 11 11 19 0 11 -6 9
-24 -8 -13 -13 -23 -28 -22 -33 2 -6 1 -8 -1 -4 -3 5 -14 1 -26 -7 -44 -30
-33 -13 26 44 34 33 64 58 66 56 2 -3 -1 -11 -7 -18 -7 -8 -9 -17 -5 -20 14
-14 20 -6 18 26 -2 23 6 41 26 65 71 81 176 254 231 382 79 180 110 329 111
535 l1 140 10 -97 c12 -103 25 -143 20 -56 -2 29 -1 46 3 38 11 -25 31 -40 52
-40 11 0 23 -4 26 -10 3 -5 24 -10 46 -10 21 0 39 5 39 10 0 12 77 14 82 1 2
-4 49 -11 106 -14 l102 -5 0 39 c0 35 3 39 25 39 14 0 34 6 45 13 17 10 22 9
31 -3 16 -24 3 272 -16 360 -46 213 -88 336 -171 502 -245 489 -781 939 -1419
1191 -402 158 -992 292 -1082 246z m-1725 -2554 c36 -30 47 -75 28 -119 -36
-86 -151 -91 -194 -9 -22 41 -15 82 22 119 44 44 99 47 144 9z m4002 -763 c0
-5 -12 -20 -28 -35 -18 -18 -32 -23 -41 -18 -11 7 -10 13 7 31 l21 22 -6 -23
c-6 -21 -5 -23 10 -10 9 7 17 20 17 27 0 8 5 14 10 14 6 0 10 -4 10 -8z m-105
-61 c-3 -6 -11 -11 -17 -11 -6 0 -6 6 2 15 14 17 26 13 15 -4z m35 -10 c0 -5
-7 -12 -16 -15 -14 -5 -15 -4 -4 9 14 17 20 19 20 6z m-545 -40 c3 -5 -5 -17
-17 -25 -26 -18 -38 -5 -18 19 14 17 26 19 35 6z m-120 -61 c-10 -11 -23 -20
-29 -20 -6 0 0 9 14 20 32 25 38 25 15 0z m30 -9 c-3 -6 -11 -11 -16 -11 -5 0
-4 6 3 14 14 16 24 13 13 -3z m505 -15 c0 -2 -8 -10 -17 -17 -16 -13 -17 -12
-4 4 13 16 21 21 21 13z m-560 -30 c0 -25 -19 -38 -58 -40 -23 -1 -44 -5 -48
-9 -4 -4 -12 -7 -18 -7 -6 0 -1 7 11 15 12 8 29 12 38 9 16 -7 55 21 55 39 0
6 -8 3 -18 -6 -10 -10 -22 -17 -27 -17 -4 0 2 9 14 19 23 20 51 18 51 -3z
m-150 -81 c-14 -8 -32 -17 -40 -21 -8 -4 -18 -12 -21 -17 -4 -5 -13 -7 -20 -5
-14 5 67 55 91 57 8 0 4 -6 -10 -14z m-110 -95 c0 -5 -5 -10 -11 -10 -5 0 -7
5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-235 -79 c-6 -5 -23 -12 -40 -16
l-30 -6 30 15 c35 17 53 20 40 7z m-648 -137 c-3 -3 -12 -4 -19 -1 -8 3 -5 6
6 6 11 1 17 -2 13 -5z m71 -1 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17 4 22 1 32
-1 23 -4z m-71 -19 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M7813 9154 c-10 -28 11 -86 37 -102 24 -15 24 -15 8 3 -16 17 -16 19
0 32 15 12 14 13 -6 3 -22 -11 -23 -10 -17 12 5 19 4 20 -5 8 -9 -12 -10 -7
-5 23 6 38 -1 50 -12 21z"/>
<path d="M7920 9007 c0 -2 14 -16 32 -33 l32 -29 -25 32 c-20 27 -39 41 -39
30z"/>
<path d="M8002 8913 c14 -18 32 -49 38 -68 7 -20 14 -34 16 -32 3 2 0 17 -6
32 -8 20 -7 31 1 41 10 12 8 13 -6 8 -15 -6 -17 -3 -12 16 4 17 3 20 -5 12 -9
-9 -17 -7 -32 6 -13 11 -11 5 6 -15z"/>
<path d="M8071 8754 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8251 8748 c-1 -9 -4 -25 -7 -35 -5 -15 -4 -15 5 -3 9 12 11 13 11 1
0 -8 2 -12 5 -10 2 3 0 18 -4 35 -5 16 -10 21 -10 12z"/>
<path d="M8082 8657 c-3 -76 25 -116 88 -124 33 -5 40 -3 40 11 0 19 -1 19
-35 6 l-26 -10 18 30 c16 27 16 32 3 40 -13 8 -12 10 3 10 21 0 22 13 3 29
-11 10 -15 8 -19 -6 -4 -13 -5 -12 -6 6 -1 19 -4 21 -15 12 -11 -9 -15 -9 -19
1 -3 7 -6 -2 -6 -19 -1 -51 -19 -39 -24 15 l-3 47 -2 -48z m68 -47 c0 -5 -4
-10 -9 -10 -6 0 -13 5 -16 10 -3 6 1 10 9 10 9 0 16 -4 16 -10z"/>
<path d="M8252 8595 c-17 -37 -14 -45 4 -12 9 16 14 31 11 33 -2 2 -9 -7 -15
-21z"/>
<path d="M8525 8590 c4 -14 13 -28 19 -32 20 -13 18 1 -4 29 -22 28 -22 28
-15 3z"/>
<path d="M8662 8565 c-12 -14 -18 -25 -13 -25 11 0 45 39 39 45 -2 3 -14 -6
-26 -20z"/>
<path d="M8588 8533 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8910 8363 c0 -5 9 -22 20 -40 22 -36 76 -53 113 -35 18 9 16 9 -15
5 -22 -3 -44 -1 -51 6 -8 6 -17 7 -22 3 -4 -4 -5 7 -1 23 5 22 4 26 -4 15 -8
-13 -11 -11 -16 8 -6 20 -24 32 -24 15z"/>
<path d="M3696 8240 c-61 -24 -89 -50 -121 -114 -46 -93 -24 -198 57 -271 50
-45 80 -55 162 -55 70 1 124 28 175 88 29 36 54 55 79 61 20 6 133 10 251 11
l213 0 284 -282 c156 -155 291 -286 301 -291 9 -6 115 -12 235 -15 l218 -5 24
-32 c50 -66 159 -70 227 -8 64 58 69 146 14 219 -60 79 -184 84 -242 11 -34
-43 -53 -47 -244 -47 l-183 0 -286 284 c-157 156 -295 289 -307 295 -14 7
-109 11 -274 11 l-253 0 -55 60 c-90 96 -172 120 -275 80z m167 -140 c47 -53
33 -137 -30 -169 -63 -32 -146 7 -159 76 -20 107 115 175 189 93z m1941 -583
c-9 -24 -23 -11 -17 14 3 12 9 17 15 11 5 -5 6 -16 2 -25z m26 -7 c0 -5 -4
-10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
<path d="M8381 8132 c-1 -20 18 -52 31 -52 7 0 5 7 -4 18 -9 9 -18 24 -21 32
-4 10 -6 11 -6 2z"/>
<path d="M8427 8067 c-6 -17 3 -27 50 -51 33 -17 128 -22 137 -8 3 5 -8 6 -24
4 -40 -6 -102 7 -95 19 4 5 -5 9 -20 9 -17 0 -28 7 -34 22 -6 17 -9 18 -14 5z"/>
<path d="M3415 7460 c-116 -37 -186 -146 -166 -257 11 -60 56 -129 103 -160
32 -22 56 -28 108 -31 95 -6 128 8 198 83 l60 65 404 0 403 -1 160 -155 c88
-86 174 -164 190 -175 28 -18 54 -19 433 -19 401 0 433 2 454 34 15 21 8 73
-11 90 -18 16 -52 18 -410 16 -414 -1 -410 -1 -461 49 -15 14 -87 85 -161 158
-74 72 -147 136 -162 142 -18 7 -168 11 -424 11 -440 0 -424 -2 -476 70 -47
66 -163 105 -242 80z m137 -147 c94 -90 -16 -228 -133 -167 -36 18 -63 74 -54
114 7 31 50 75 80 83 36 9 79 -3 107 -30z"/>
<path d="M8472 6760 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M8453 6683 c-1 -33 0 -35 8 -15 5 13 5 30 1 38 -5 9 -8 1 -9 -23z"/>
<path d="M6271 6654 c-12 -20 -20 -38 -18 -41 3 -2 14 13 26 33 12 20 20 38
18 41 -3 2 -14 -13 -26 -33z"/>
<path d="M6680 6661 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M7096 6619 c-3 -19 -8 -51 -11 -72 -4 -22 -10 -35 -16 -31 -6 3 -8
13 -5 21 3 8 1 11 -4 8 -6 -3 -10 -2 -10 2 0 5 -16 15 -35 22 -19 7 -42 19
-50 27 -13 14 -15 13 -16 -3 0 -10 -8 -74 -18 -143 -10 -69 -16 -128 -14 -132
6 -12 141 -10 148 2 8 13 47 321 41 327 -3 3 -7 -10 -10 -28z"/>
<path d="M6553 6625 c2 -18 -6 -21 -68 -26 -38 -3 -56 -6 -39 -7 17 -1 34 -5
37 -9 8 -7 -47 -35 -76 -38 -24 -2 -33 21 -17 40 10 13 9 15 -11 15 -23 0 -32
-10 -82 -92 -20 -32 -23 -58 -6 -41 8 8 22 8 47 1 21 -6 75 -8 122 -6 142 8
141 9 168 -78 l22 -74 81 0 82 0 -7 33 c-3 17 -15 55 -26 82 -10 28 -28 75
-40 105 -11 30 -18 43 -15 28 4 -22 2 -25 -14 -21 -10 3 -33 -3 -50 -11 -24
-13 -36 -14 -51 -6 -12 6 -20 16 -19 23 1 7 -7 32 -19 57 -12 25 -21 36 -19
25z"/>
<path d="M6063 6561 c-16 -21 -35 -52 -44 -67 -9 -16 -38 -62 -63 -102 -25
-41 -46 -76 -46 -78 0 -2 37 -4 83 -4 l83 0 30 53 c17 28 50 83 73 120 23 38
40 74 37 80 -3 8 -5 8 -5 -1 -1 -8 -10 -25 -21 -39 -15 -19 -20 -21 -20 -9 0
9 -6 15 -12 14 -7 -2 -12 3 -10 11 2 9 -4 12 -18 8 -13 -3 -20 0 -20 9 0 8 -4
14 -10 14 -5 0 -7 7 -4 15 11 27 -5 16 -33 -24z"/>
<path d="M8331 6269 c-14 -42 -7 -49 9 -9 7 17 10 33 8 36 -3 3 -11 -9 -17
-27z"/>
<path d="M8258 6115 c-6 -14 -15 -25 -20 -25 -4 0 -8 -5 -8 -11 0 -6 -10 -23
-21 -37 -21 -26 -22 -26 -16 -4 4 19 3 21 -9 11 -11 -9 -14 -9 -14 1 0 8 -2
11 -5 8 -3 -3 1 -19 8 -37 l14 -32 24 33 c30 42 72 118 64 118 -3 0 -11 -11
-17 -25z"/>
<path d="M8000 5964 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M2428 4709 c-137 -20 -236 -105 -273 -234 -25 -86 -18 -243 14 -309
49 -101 149 -168 274 -187 34 -5 214 -9 400 -9 371 0 382 -2 412 -60 19 -38
19 -93 -1 -135 -32 -67 -8 -65 -586 -67 l-523 -3 0 -120 0 -120 565 0 c631 0
614 -2 713 71 37 27 56 52 80 102 31 65 32 72 32 197 0 112 -3 136 -21 176
-44 95 -152 170 -272 190 -31 5 -211 9 -400 9 -382 0 -391 1 -418 65 -18 45
-18 89 2 130 31 65 28 65 568 65 l487 0 -3 123 -3 122 -495 1 c-272 1 -521 -2
-552 -7z"/>
<path d="M3827 4713 c-3 -4 -4 -287 -3 -628 l1 -620 138 -3 137 -3 -2 628 -3
628 -132 3 c-72 1 -134 -1 -136 -5z"/>
<path d="M4395 4701 c3 -11 53 -108 111 -217 212 -399 302 -569 412 -784 93
-180 113 -206 167 -225 62 -22 230 -19 281 4 52 23 74 54 156 211 68 129 155
294 397 749 77 146 138 268 135 272 -2 4 -68 8 -147 8 l-142 1 -45 -87 c-24
-49 -92 -178 -150 -288 -59 -110 -157 -296 -219 -413 -81 -151 -118 -212 -129
-210 -15 3 -64 91 -254 458 -55 107 -115 222 -133 255 -18 33 -58 110 -90 172
l-57 112 -149 0 c-141 0 -150 -1 -144 -18z"/>
<path d="M6656 4706 c-22 -8 -52 -27 -67 -43 -14 -15 -138 -233 -274 -483
-136 -250 -278 -512 -316 -581 -38 -70 -69 -129 -69 -133 0 -3 67 -6 149 -6
l149 0 32 63 c104 199 494 914 505 926 7 7 18 11 23 7 6 -3 38 -59 72 -124 34
-64 91 -171 126 -238 35 -67 64 -124 64 -127 0 -4 -86 -8 -191 -9 l-192 -3
-58 -110 c-32 -60 -59 -113 -59 -117 0 -5 143 -8 318 -8 l317 0 40 -81 c22
-45 52 -104 68 -130 l27 -49 145 0 c102 0 145 3 145 11 0 7 -24 57 -54 113
-29 56 -82 155 -116 221 -103 197 -379 704 -429 789 -60 101 -89 118 -221 123
-67 2 -107 -1 -134 -11z"/>
<path d="M8693 4000 c-3 -11 -8 -20 -12 -20 -4 0 -15 -20 -25 -44 -14 -33 -22
-43 -35 -38 -14 5 -14 4 -2 -11 7 -9 10 -17 6 -17 -4 0 -14 8 -21 17 -12 17
-14 17 -32 -5 -20 -23 -85 -31 -97 -12 -12 20 -90 -42 -81 -65 7 -18 -28 -48
-51 -43 -13 3 -17 12 -16 32 1 16 1 27 -1 25 -5 -6 -77 -140 -110 -204 -17
-33 -39 -71 -48 -85 -9 -14 -19 -34 -22 -45 -6 -19 -2 -20 136 -18 136 2 142
3 155 25 87 153 132 252 127 274 -3 13 -9 22 -13 20 -4 -3 -7 4 -8 14 -2 24
22 33 40 16 16 -16 16 -15 73 91 41 77 56 113 48 113 -3 0 -8 -9 -11 -20z
m-382 -257 c-12 -20 -14 -14 -5 12 4 9 9 14 11 11 3 -2 0 -13 -6 -23z m-88
-168 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z"/>
<path d="M8366 3889 c-16 -32 -27 -61 -25 -64 3 -2 17 23 33 56 15 33 26 62
24 64 -2 2 -17 -23 -32 -56z"/>
<path d="M8866 3933 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M9148 3943 c17 -2 47 -2 65 0 17 2 3 4 -33 4 -36 0 -50 -2 -32 -4z"/>
<path d="M8391 3874 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9570 3884 c0 -4 7 -15 15 -24 15 -16 13 -17 -25 -15 -31 2 -40 -1
-36 -11 3 -8 -1 -14 -8 -14 -8 0 -16 -4 -18 -10 -1 -5 -30 -12 -63 -16 -45 -4
-65 -12 -82 -31 -18 -19 -31 -24 -61 -21 -28 2 -37 7 -36 21 1 9 -2 17 -7 17
-5 0 -9 5 -9 11 0 6 10 9 23 7 15 -3 24 0 24 9 0 7 -11 13 -24 13 -12 0 -23
-4 -23 -10 0 -5 -9 -10 -19 -10 -11 0 -21 -3 -23 -8 -1 -4 -57 -5 -123 -2 -89
4 -119 8 -117 18 2 13 -24 17 -32 4 -7 -11 -94 -6 -109 6 -9 8 -19 -2 -39 -39
l-26 -49 317 0 316 0 65 -130 65 -129 147 -1 147 0 -40 78 c-23 42 -58 106
-79 142 -21 36 -50 89 -65 119 -26 52 -55 91 -55 75z m80 -154 c16 -31 17 -40
6 -40 -7 0 -16 10 -19 23 -2 12 -8 30 -12 40 -14 34 5 16 25 -23z m-26 -22 c3
-16 2 -28 -3 -28 -5 0 -11 16 -13 35 -5 39 6 34 16 -7z"/>
<path d="M8823 3855 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z"/>
<path d="M8370 3830 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M8570 3774 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M10281 3776 c-1 -14 -7 -17 -27 -13 -15 2 -28 0 -30 -8 -3 -6 -18
-12 -34 -12 -23 0 -30 5 -31 21 0 12 -3 15 -6 8 -2 -6 -9 -10 -14 -6 -5 3 -10
-14 -10 -38 -1 -39 -2 -40 -8 -13 -6 25 -8 20 -14 -34 -4 -35 -7 -97 -7 -137
l0 -74 135 0 135 0 0 148 c0 81 -4 142 -8 136 -10 -15 -37 -23 -48 -16 -5 4
-15 18 -21 32 -9 20 -12 21 -12 6z"/>
<path d="M4080 2811 l0 -301 155 0 c189 0 243 15 316 90 57 58 79 119 79 214
-1 121 -53 206 -158 258 -64 32 -69 33 -229 36 l-163 4 0 -301z m325 180 c77
-35 121 -113 113 -200 -6 -63 -34 -117 -76 -149 -32 -25 -44 -27 -144 -31
l-108 -3 0 201 0 201 88 0 c63 0 98 -6 127 -19z"/>
<path d="M5550 2963 c-35 -82 -92 -213 -127 -292 -34 -80 -63 -148 -63 -153 0
-4 24 -8 54 -8 l54 0 28 65 28 65 146 0 145 0 24 -65 25 -65 57 0 57 0 -34 88
c-20 48 -44 105 -54 127 -22 48 -145 343 -153 368 -5 14 -18 17 -65 17 l-59 0
-63 -147z m170 -95 c25 -61 47 -115 48 -119 2 -5 -42 -9 -97 -9 -56 0 -101 3
-101 6 0 4 15 45 34 93 19 47 39 98 45 114 6 15 14 27 18 27 5 0 28 -50 53
-112z"/>
<path d="M6667 3104 c-4 -4 -7 -27 -7 -50 l0 -43 96 -3 95 -3 -1 -231 c0 -127
2 -238 6 -247 5 -13 19 -17 55 -17 l49 0 0 250 0 250 101 0 100 0 -3 48 -3 47
-241 3 c-132 1 -243 -1 -247 -4z"/>
<path d="M8098 3088 c-8 -13 -30 -61 -50 -108 -20 -47 -72 -169 -117 -272 -44
-103 -81 -190 -81 -193 0 -3 26 -5 57 -3 l57 3 25 62 26 63 145 0 146 0 24
-65 24 -65 58 0 c32 0 58 2 58 5 0 5 -64 154 -86 200 -7 17 -25 57 -38 90 -14
33 -47 114 -75 180 l-49 120 -55 3 c-47 3 -56 0 -69 -20z m84 -150 c9 -24 30
-76 47 -117 17 -40 31 -75 31 -77 0 -2 -45 -4 -101 -4 -77 0 -100 3 -96 13 57
150 90 227 96 227 3 0 14 -19 23 -42z"/>
<path d="M2150 2831 c-15 -29 -3 -49 33 -53 36 -4 272 -4 862 1 357 2 405 4
375 16 l-35 13 30 3 c17 1 5 5 -30 9 l-60 7 60 3 c50 2 55 4 30 10 -16 4 -305
8 -642 9 -595 1 -613 0 -623 -18z"/>
<path d="M9100 2840 l-25 -8 25 -2 25 -2 -25 -8 c-21 -7 -22 -8 -5 -9 16 -2
14 -5 -10 -16 -26 -12 21 -14 365 -16 217 -2 431 -3 475 -2 44 0 162 1 262 2
174 1 182 2 188 21 16 51 29 50 -634 49 -339 -1 -627 -5 -641 -9z"/>
<path d="M3023 2118 c-12 -6 -26 -23 -32 -38 -15 -45 6 -72 72 -94 48 -15 57
-22 57 -42 0 -30 -36 -40 -84 -24 -34 11 -56 8 -56 -9 0 -14 50 -31 93 -31 57
0 87 22 87 64 0 40 -16 55 -79 77 -38 13 -46 20 -46 40 0 21 4 24 40 23 22 0
46 -2 54 -5 8 -2 16 3 18 12 7 31 -79 49 -124 27z"/>
<path d="M3300 2004 c0 -104 2 -124 15 -124 12 0 15 16 15 80 0 44 4 80 8 80
4 0 22 -29 40 -65 17 -36 38 -65 45 -65 7 0 28 30 47 68 l35 67 5 -80 c4 -66
8 -80 23 -83 15 -3 17 8 17 117 0 119 0 121 -23 121 -18 0 -30 -15 -60 -76
-21 -43 -42 -73 -47 -68 -4 5 -22 36 -39 69 -36 68 -44 78 -66 81 -13 2 -15
-17 -15 -122z"/>
<path d="M3765 2098 c-7 -18 -30 -71 -49 -116 -41 -96 -42 -102 -18 -102 10 0
22 12 29 30 11 28 14 30 67 30 52 0 57 -2 71 -30 9 -17 24 -30 34 -30 17 0 14
12 -27 113 -26 61 -51 118 -55 125 -14 22 -38 13 -52 -20z m55 -74 c11 -26 20
-48 20 -50 0 -2 -18 -4 -40 -4 -29 0 -40 4 -40 15 0 18 27 85 34 85 3 0 14
-21 26 -46z"/>
<path d="M4056 2122 c-14 -3 -16 -21 -16 -123 0 -112 1 -119 20 -119 17 0 20
7 20 40 0 38 1 40 33 40 27 0 35 -6 52 -38 12 -23 29 -38 43 -40 27 -4 28 5 2
38 -25 32 -25 45 0 70 27 27 27 83 -1 109 -20 18 -108 32 -153 23z m122 -44
c7 -7 12 -21 12 -33 0 -32 -20 -45 -67 -45 l-43 0 0 45 0 45 43 0 c24 0 48 -5
55 -12z"/>
<path d="M4355 2122 c-16 -17 -2 -32 30 -32 l35 0 0 -105 c0 -98 1 -105 20
-105 19 0 20 7 20 105 l0 105 40 0 c29 0 40 4 40 15 0 8 -6 15 -12 16 -61 4
-169 5 -173 1z"/>
<path d="M4873 2122 c-22 -3 -23 -7 -23 -123 l0 -119 65 0 c39 0 78 6 95 15
65 33 81 131 31 187 -24 27 -37 33 -87 38 -33 3 -69 4 -81 2z m132 -57 c18
-18 25 -35 25 -65 0 -60 -47 -97 -111 -88 -23 3 -24 7 -27 91 l-3 87 46 0 c35
0 52 -6 70 -25z"/>
<path d="M5538 2122 c-34 -2 -48 -7 -48 -18 0 -10 12 -14 40 -14 l40 0 0 -105
c0 -98 1 -105 20 -105 19 0 20 7 20 105 l0 105 35 0 c28 0 35 4 35 20 0 22 4
21 -142 12z"/>
<path d="M5867 2117 c-13 -10 -37 -63 -104 -224 -11 -27 33 -11 49 17 16 28
21 30 73 30 53 0 57 -1 66 -30 7 -20 18 -30 31 -30 11 0 18 4 16 8 -1 5 -23
58 -48 120 -24 61 -49 113 -56 116 -7 3 -19 -1 -27 -7z m36 -90 c9 -23 17 -46
17 -50 0 -4 -18 -7 -41 -7 -29 0 -40 4 -36 13 2 6 10 29 18 50 7 20 15 37 19
37 3 0 13 -19 23 -43z"/>
<path d="M6497 2124 c-4 -4 -7 -61 -7 -126 l0 -118 80 0 c64 0 80 3 80 15 0
12 -13 15 -60 15 l-59 0 -3 107 c-3 98 -11 127 -31 107z"/>
<path d="M6806 2111 c-40 -26 -55 -57 -56 -109 0 -82 42 -122 126 -122 39 0
51 5 80 34 30 30 34 40 34 88 -1 56 -13 78 -60 111 -32 23 -88 22 -124 -2z
m123 -47 c32 -40 29 -106 -5 -133 -59 -46 -134 -8 -134 67 0 57 31 92 80 92
30 0 43 -6 59 -26z"/>
<path d="M7097 2124 c-2 -3 12 -58 32 -124 31 -106 38 -120 57 -120 19 0 25
11 43 69 12 38 21 74 21 79 0 6 4 13 9 16 5 3 21 -33 35 -80 24 -76 29 -85 49
-82 19 3 27 19 54 108 38 124 40 140 15 133 -13 -3 -25 -28 -42 -89 -13 -46
-26 -84 -30 -84 -4 0 -18 36 -31 81 -14 48 -30 84 -40 90 -21 11 -20 14 -50
-88 -13 -46 -27 -83 -30 -83 -4 0 -17 38 -30 84 -16 59 -29 86 -41 89 -9 3
-19 3 -21 1z"/>
<path d="M7583 2123 c-22 -4 -23 -8 -23 -124 l0 -119 85 0 c69 0 85 3 85 15 0
12 -14 15 -65 15 l-65 0 0 40 0 40 60 0 c49 0 58 3 54 15 -5 11 -21 15 -60 15
l-54 0 0 35 0 35 66 0 c57 0 65 2 62 18 -3 14 -15 17 -63 18 -33 1 -70 0 -82
-3z"/>
<path d="M7903 2123 l-43 -4 0 -120 c0 -112 1 -119 20 -119 17 0 20 7 20 40 0
38 2 40 30 40 24 0 35 -8 55 -40 16 -25 33 -40 45 -40 25 0 25 3 -5 47 l-24
37 24 24 c32 32 33 81 3 109 -26 24 -64 31 -125 26z m100 -54 c5 -9 7 -28 3
-42 -6 -25 -11 -27 -56 -27 l-50 0 0 46 0 45 46 -3 c30 -2 51 -9 57 -19z"/>
<path d="M8440 2123 c-8 -3 -30 -19 -47 -36 -27 -26 -33 -38 -33 -74 0 -50 20
-95 52 -117 31 -22 110 -21 138 2 33 27 18 46 -20 27 -67 -35 -119 -7 -127 67
-5 40 -2 50 20 72 28 28 83 36 104 15 7 -7 19 -9 27 -6 57 22 -56 71 -114 50z"/>
<path d="M8755 2118 c-64 -35 -87 -90 -66 -158 16 -53 56 -80 118 -80 75 0
123 47 123 122 0 86 -104 155 -175 116z m102 -43 c12 -9 25 -31 29 -49 18 -97
-71 -152 -138 -86 -27 27 -30 36 -25 73 4 26 14 48 27 59 27 22 78 23 107 3z"/>
<path d="M9078 2110 c-21 -16 -28 -30 -28 -55 0 -38 23 -57 87 -74 46 -13 60
-33 37 -56 -18 -18 -57 -20 -85 -4 -12 6 -28 8 -37 4 -31 -12 24 -45 74 -45
79 0 114 32 94 85 -11 28 -22 36 -80 55 -37 12 -45 19 -45 40 0 22 5 25 38 28
21 2 44 -2 51 -7 10 -8 16 -7 25 3 16 19 -9 37 -62 43 -33 4 -48 0 -69 -17z"/>
<path d="M9333 2118 c-9 -16 9 -28 43 -28 l34 0 0 -105 c0 -98 1 -105 20 -105
19 0 20 7 20 104 l0 105 38 3 c24 2 37 8 37 17 0 11 -20 14 -93 15 -52 1 -96
-2 -99 -6z"/>
<path d="M5217 2006 c-26 -63 -47 -118 -47 -121 0 -3 9 -5 19 -5 12 0 23 11
30 30 10 29 12 30 70 30 57 0 59 -1 70 -30 7 -20 17 -30 30 -30 12 0 21 2 21
3 0 2 -22 55 -49 118 -42 97 -53 114 -73 117 -22 3 -28 -7 -71 -112z m92 27
c8 -21 16 -44 18 -50 4 -9 -7 -13 -36 -13 -23 0 -41 4 -41 10 0 17 32 90 39
90 4 0 13 -17 20 -37z"/>
<path d="M6135 1916 c-21 -15 -12 -36 16 -36 12 0 19 7 19 19 0 27 -13 33 -35
17z"/>
<path d="M9613 1923 c-21 -8 -15 -43 6 -43 11 0 23 5 27 11 8 14 -17 38 -33
32z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
